import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import CustomerModel from '../../model/customer.model';
import {environment} from '../../environments/environment';
import Pagination from '../../model/pagination';
import QueryEncoder from '../queryEncoder';
import ContactModel from '../../model/contact.model';

@Injectable()
export default class ContactService {
  public constructor(private http: HttpClient) {
  }

  public show(id: number): Observable<ContactModel> {
    return this.http.get<ContactModel>(environment.apiUrl + '/contacts/' + id);
  }

  public list(query?: string, page?: number, limit?: number, sort?: string, direction?: string, additionalInfo?: any): Observable<Pagination<ContactModel>> {
    query = query || '';
    page = page || 1;
    limit = limit || 15;
    sort = sort || '';

    let sorting = {};
    sorting[sort] = direction;

    let q = {query, page, limit, sorting};

    if (additionalInfo) {
      Object.assign(q, additionalInfo);
    }

    return this.http
      .get<Pagination<ContactModel>>(environment.apiUrl + '/contacts?' + QueryEncoder.encodeURI(q));
  }

  public delete(contact: ContactModel): Observable<any> {
    return this.http.delete(environment.apiUrl + '/contacts/' + contact.id);
  }

  public update(contact: ContactModel): Observable<any> {
    return this.http.put(environment.apiUrl + '/contacts/' + contact.id, contact);
  }

  public create(contact: ContactModel): Observable<ContactModel> {
    return this.http.post<ContactModel>(environment.apiUrl + '/contacts', contact);
  }
}
